import { ArrowDown } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowThickDown = mkIcon(ArrowDown);